import { urlQueryString } from '@azgaz/azgaz-ui/connect/lib/utils';

const removeModelFromUrl = () => {
  const { model, ...withoutModel } = urlQueryString.get();
  urlQueryString.set(withoutModel);
};

export default removeModelFromUrl;
